import clinic from "../../../images/clinic.svg";
import cptsEss from "../../../images/cptsEss.svg";
import gp from "../../../images/gp.svg";
import hospital from "../../../images/hospital.svg";
import otherProfessional from "../../../images/otherProfessional.svg";
import specialist from "../../../images/specialist.svg";
import { LANG_FR_FR, blogPath, infoPath, pressPath } from "../../../constants";
import { t } from "../../../translations";

const locale = LANG_FR_FR;

const individuals = [
  {
    name: "Médecins spécialistes",
    description:
      "Créez un canal de communication efficace et valorisé avec vos correspondants.",
    href: "/medecins-specialistes",
    icon: specialist,
  },
  {
    name: "Médecins généralistes",
    description:
      "Découvrez et sollicitez facilement les médecins et organisations accessibles sur votre territoire.",
    href: "/medecins-generalistes",
    icon: gp,
  },
  {
    name: "Autres professionnels de santé",
    description:
      "La téléexpertise et Omnidoc sont désormais ouverts à tous les professionnels de santé.",
    href: "/autres-professionnels-de-sante",
    icon: otherProfessional,
  },
];
const groups = [
  {
    name: "Hôpitaux publics et ESPIC",
    description:
      "Sécurisez et valorisez les avis informels. Améliorez le lien avec la ville.",
    href: "/hopitaux",
    icon: hospital,
  },
  {
    name: "CPTS et ESS",
    description:
      "Renforcez les liens entre premier et second recours sur votre territoire.",
    href: "/cpts-ess",
    icon: cptsEss,
  },
  {
    name: "Cliniques et cabinets de groupe",
    description:
      "Centralisez et valorisez les sollicitations de vos correspondants.",
    href: "/cliniques-et-cabinets-de-groupe",
    icon: clinic,
  },
];
const resources = [
  {
    name: t(locale, "navigation.news"),
    description: "",
    href: blogPath({ locale }),
  },
  {
    name: "FAQ",
    description: "",
    href: infoPath({ locale }),
  },
  {
    name: "Presse",
    description: "",
    href: pressPath({ locale }),
  },
  {
    name: "On recrute !",
    description: "",
    href: "https://www.welcometothejungle.com/fr/companies/omnidoc",
  },
];

const solutions = [
  { name: "Téléexpertise", description: "", href: "/teleexpertise" },
  { name: "e-RCP", description: "", href: "/RCP" },
  {
    name: "Téléconsultation",
    description: "",
    href: "/teleconsultation",
  },
];

export const rolesMenuItem = {
  name: "Vous êtes …",
  children: [
    { name: "Organisations", children: groups },
    { name: "Professionnels de Santé", children: individuals },
  ],
};

export const otherMenuItems = [
  {
    name: "Nos solutions",
    children: [{ name: "solutionsmenu", children: solutions }],
  },
  { name: "Interopérabilité", href: "/interoperabilite" },
  { name: "Tarifs", href: "/tarifs" },
  { name: "Plus", children: [{ name: "plusmenu", children: resources }] },
];
